<template>
  <div class="has-text-centered">
    <div class="app-block p-md">
      <div>
        <p><strong>Votre formation est financée par un organisme</strong></p>
      </div>
      <hr>
      <div class="has-text-centered">
        <transition name="slide-fade">
          <div class="has-text-danger">
            {{ errorMsg }}
          </div>
        </transition>
        <button
            :class="'button button-save ' + isLoading"
            @click="send"
        >
          Ma formation est financée par un organisme
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import settings from 'services/organization'

export default {
  data() {
    return {
      isLoading: '',
      errorMsg: '',
      discounts: null
    }
  },
  computed: {
    ...mapGetters({
      status: 'orders/status',
      statusMessage: 'orders/statusMessage'
    }),
    ...mapGetters(
        'orders', [
          'orderRef',
          'cartChoices',
          'selectedOrder',
          'isSchoolingOrder',
          'candidateSchoolingInOrder',
          'candidateSchoolingDetails'
        ]
    ),
    ...mapGetters('organization', [
      'currentScholarYear',
      'nextScholarYear'
    ]),
    application() {
      return this.candidate.applications
    },
    discountDate() {
      if (this.discounts) {
        let dates = this.discounts['date_discount'][0].date.split('/')
        const currentYear = moment().year()
        return moment().year(currentYear).month(dates[1] - 1).date(dates[0]).format('LL')
      }
    },
    discountValue() {
      if (this.discounts) {
        return this.discounts['date_discount'][0].value
      }
    },
  },
  props: {
    school: {type: Object},
    credit: {type: Number},
    totalCheckout: {type: Number},
    totalSchoolingCheckout: {type: Number},
    candidate: {type: Object},
    candidates: {type: Array},
    guarantor: {type: Number},
    discount: {type: Array},
  },
  created() {
    settings.settings().then((result) => {
      this.discounts = JSON.parse(result.data[5].value)
    }).catch((err) => {
      this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
    })
  },
  methods: {
    ...mapActions(
        'orders', [
          'orderCheckout'
        ]
    ),
    toggleLoading: function () {
      this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
    },
    totalPaiement() {
      let total = this.totalCheckout - this.totalSchoolingCheckout
      let totalSchooling = this.totalSchoolingCheckout
      /*if (this.cartDiscount()) {
        totalSchooling = Math.ceil(totalSchooling - (totalSchooling * 0.05))
      }*/
      return total + totalSchooling
    },
    cartDiscount() {
      if (this.discounts) {
        let dates = this.discounts['date_discount'][0].date.split('/')
        let schooling = this.candidateSchoolingInOrder(this.candidates, 'pending')
        let now = moment()
        const currentYear = moment().year()
        const endDiscount = moment().year(currentYear).month(dates[0]).date(dates[1])
        return (schooling && schooling.applications.choices[0].scholar_year === this.nextScholarYear) && moment(now).isBefore(endDiscount)
      }
    },
    send: function () {
      this.toggleLoading()
      const order = {}
      order.id = this.selectedOrder ? this.selectedOrder.id : this.orderRef
      order.cart = this.cartChoices
      order.guarantor = this.guarantor
      order.order_date = new Date()
      order.payment_mode = 'BANK-ORGA'
      order.credit = this.credit
      order.discount = this.discount
      order.payment_total = this.totalPaiement()
      order.payment_currency = this.school.fees_currency
      order.payment_number = 1
      order.school = this.$route.params.school
      order.payments = [{
        'date': new Date(),
        'amount': this.totalPaiement(),
        'number': 1
      }]
      this.orderCheckout(order).then((result) => {
        if (this.status === 200) {
          this.toggleLoading()
          this.$emit('send')
        } else if (this.getStatus === 403) {
          this.toggleLoading()
          this.$emit('notAuthenticated')
        } else {
          this.toggleLoading()
          if (this.statusMessage) {
            this.errorMsg = this.statusMessage
          } else {
            this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
          }
        }
      }).catch(() => {
        this.toggleLoading()
        if (this.statusMessage) {
          this.errorMsg = this.statusMessage
        } else {
          this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
        }
      })
    }
  }

}
</script>
